<template>
  <soha-page-loading v-if="loading" />
  <div class="card card-custom gutter-b example example-compact p-8" v-else>
    <soha-no-access
      v-if="!access"
      :message="$t(`${I18nPrefix}ACCESS_MESSAGE`)"
    />
    <div v-else>
      <div class="row m-0">
        <div
          class="col-md-10 col-sm-9 col-12 px-0 py-4 text-center text-sm-left"
        >
          <span class="soha-page-title">{{
            $t(`${I18nPrefix}PAGE_TITLE`)
          }}</span>
        </div>
        <div class="col-md-2 col-sm-3 col-12">
          <soha-button
            class="w-100"
            name="insertcompetencyBtn"
            icon="plus"
            :text="$t(`${I18nPrefix}ADD`)"
            @click="$bvModal.show('addcompetency')"
          />
        </div>
      </div>
      <div class="row mx-0 mt-10">
        <div class="col-12 soha-competency-title">
          {{ $t(`${I18nPrefix}COMPETENCIES_LIST`) }}
        </div>
      </div>
      <div class="row mx-0 mt-5">
        <div
          v-for="competency in competencies"
          :key="competency.id"
          class="col-lg-4 col-md-6 col-sm-6 col-12 mb-8"
        >
          <div class="soha-competency-card">
            <div class="soha-competency-card-header">
              <span class="font-size-sm col-2 p-0">
                {{ $t(`${I18nPrefix}NAME`) }}:
              </span>
              <span class="soha-competency-name col-8 p-0">
                {{ competency.name }}
              </span>
              <soha-menu
                class="col-2 p-0 d-flex justify-content-start"
                v-if="competency.companyId"
              >
                <template v-slot:activator>
                  <span name="messageCardMenu" class="cursor-pointer">
                    <inline-svg src="/media/svg/soha/btn-icons/menu.svg" />
                  </span>
                </template>
                <soha-list>
                  <soha-list-item
                    :text="$t(`${I18nPrefix}DELETE_BTN`)"
                    icon="delete"
                    @click="openDeleteModal(competency.id)"
                    name="removeMessage"
                  />
                </soha-list>
              </soha-menu>
            </div>
            <div class="row m-0">
              <span class="font-size-sm col-12 px-0 pb-3 font-weight-bolder">
                {{ $t(`${I18nPrefix}DESCRIPTION`) }}:
              </span>
              <div class="soha-message-primary-text col-12 p-0">
                <p class="text-justify" v-if="competency.description">
                  {{ truncatedDescription(competency) }}
                  <span 
                    v-if="competency.description.length > 150" 
                    class="soha-show-more" 
                    @click="toggleDescription(competency)"
                  > 
                    {{competency.showMore ? $t(`${I18nPrefix}CLOSE`) : $t(`${I18nPrefix}ADD_MORE`)}}
                  </span>
                </p>
                <p v-else> - </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 col-12 mb-8">
          <last-card
            @click="$bvModal.show('addcompetency')"
            class="soha-min-h-115px"
            :text="$t(`${I18nPrefix}ADD`)"
            icon="plus"
          />
        </div>
      </div>
      <soha-modal
        id="addcompetency"
        :title="$t(`${I18nPrefix}ADD_COMPETENCIES`)"
        @hide="clearDataModal"
      >
        <template v-slot:body>
          <div class="col-12">
            <soha-text-field
              class="w-100"
              name="competencyName"
              v-model="name.value"
              :error="name.error"
              type="text"
              :placeholder="$t(`${I18nPrefix}NAME`)"
            />
          </div>
          <div class="col-12">
            <soha-text-area
              name="description"
              class="w-100"
              :placeholder="$t(`${I18nPrefix}DESCRIPTION`)"
              v-model="description"
            />
          </div>
        </template>
        <template v-slot:footer>
          <div class="col-12">
            <soha-button
              class="w-100 mt-1"
              :loading="btnLoading"
              name="insert"
              :text="$t(`${I18nPrefix}INSERT`)"
              @click="storeCompetencies()"
            />
          </div>
        </template>
      </soha-modal>
      <soha-delete-modal
        @onDelete="deleteCompetencies()"
        :loading="btnLoading"
        modal-id="deletecompetency"
        :text="$t(`${I18nPrefix}DELETE_COMPETENCY`)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ValidationMixin from "@/mixins/ValidationMixin";
import UIMixin from "@/mixins/UIMixin";
import ApiService from "@/core/services/api.service";
import LastCard from "@/view/components/base/LastCard";
export default {
  name: "Competencies",

  mixins: [ValidationMixin, UIMixin],

  components: { LastCard },

  data() {
    return {
      I18nPrefix: "PAGES.SETTING.COMPETENCIES.",
      loading: false,
      access: true,
      btnLoading: false,
      competencies: [],
      selectedcompetency: null,
      name: {
        value: null,
        error: null,
      },
      description: null,
    };
  },

  mounted() {
    this.getCompetencies(true);
  },

  methods: {
    getCompetencies(loading) {
      this.loading = loading;
      ApiService.get(
        "api/v2/companies/" + this.companyId + "/competencies"
      ).then(({ data }) => {
        if (!data.code) {
          this.competencies = data;
          this.loading = false;
        } else if (+data.code === 403) {
          this.access = false;
          this.loading = false;
        } else {
          this.errorToast(data.message);
        }
      });
    },

    openDeleteModal(id) {
      this.selectedcompetency = id;
      this.$bvModal.show("deletecompetency");
    },

    deleteCompetencies() {
      this.btnLoading = true;
      ApiService.delete(
        `api/v2/resume_reject_reason/${this.selectedcompetency}`
      ).then((data) => {
        if (+data.data.code === 202) {
          this.successToast(data.data.message);
          this.getCompetencies();
        } else {
          this.errorToast(data.data.message);
        }
        this.$bvModal.hide("deletecompetency");
        this.btnLoading = false;
        this.selectedcompetency = null;
      });
    },

    storeCompetencies() {
      this.name.error = this.validateField(
        this.name.value,
        this.$t(`${this.I18nPrefix}NAME`)
      );
      if (this.name.error) return;
      this.btnLoading = true;
      ApiService.post("api/employer/storeCompetency", {
        companyId: this.companyId,
        creatorId: this.userId,
        name: this.name.value,
        description: this.description,
      }).then((data) => {
        if (data.data.status == "ok") {
          this.successToast(data.data.message);
          this.competencies.push({
            name: this.name.value,
            id: data.data.param,
            description: this.description,
          })
          this.$bvModal.hide("addcompetency");
        } else {
          this.errorToast(data.data.message);
        }
        this.btnLoading = false;
      });
    },

    clearDataModal() {
      this.name = {
        value: null,
        error: null,
      };
      this.description = null;
    },

    truncatedDescription(competency) {
      if (competency.description?.length > 150 && !competency.showMore) {
        return competency.description.substring(0, 150) + "...";
      }
      return competency.description;
    },
    toggleDescription(item) {
      item.showMore = !item.showMore;
      this.$forceUpdate();
    }
  },

  computed: {
    ...mapGetters(["companyId", "userId"]),
  },
};
</script>

<style scoped>
.soha-competency-card {
  border: 0.077rem solid var(--box-border-color);
  border-radius: 0.462rem;
  padding: 0.769rem 1.154rem;
  height: 100%;
}
.soha-competency-title {
  font-weight: bold;
  color: var(--primary-color);
}
.soha-competency-card-header {
  display: flex;
  align-items: center;
  border-bottom: 0.077rem solid var(--box-border-color);
  padding-bottom: 0.769rem;
  margin-bottom: 0.769rem;
  color: var(--primary-color);
}
.soha-delete-competency-icon {
  position: absolute;
  left: 5%;
  top: 35%;
  cursor: pointer;
}
.soha-competency-name {
  color: var(--primary-color);
  font-weight: bold;
  text-align: right;
}
.soha-show-more {
  color: var(--secondary-color);
  cursor: pointer;
  font-size: 1.0rem;
}
</style>
